<template>
  <div class="vipBox">
    <div class="vip-h1">入会须知</div>
    <div class="vipBox-title">一、个人会员会费标准及管理</div>
    <div class="vipBox-title1">（一）个人会员</div>
    <div class="vipBox-text">1. 个人会员会费标准：</div>
    <div class="vipBox-text">（1） 学生会员：每年叁拾元整（30元/年）；</div>
    <div class="vipBox-text">（2） 普通会员：每年陆拾元整（60元/年）；</div>
    <div class="vipBox-text">
      （3） 外籍会员：每年壹佰贰拾元整（120元/年）；
    </div>
    <div class="vipBox-text">（4） 高级及荣誉会员：免缴会费。</div>
    <div class="vipBox-text">
      2.
      个人会员可按年度缴纳会费，亦可选择一次性缴纳2年及以上，最多不超过5年的会费。（会员有效期由缴费当日起到下一年度或应缴费年度同一日期止）
    </div>
    <div class="vipBox-title1">（二）续费及逾期管理</div>
    <div class="vipBox-text">1.会费按年度缴纳。本团体将以纸制版通知告知。</div>
    <div class="vipBox-text">
      2.会员在接到续费通知后一个月内，请主动缴纳会费；
    </div>
    <div class="vipBox-text">
      3.会员逾期不缴纳会费达两年，且无特殊原因，则按自动退会处理，取消会籍，《会员证书》声明作废并在本会网站和相关媒体上予以公布。
    </div>
    <div class="vipBox-title">二、个人会员权利</div>
    <div class="vipBox-text">
      1. 本团体内的选举权、被选举权和表决权（不含外籍会员）；
    </div>
    <div class="vipBox-text">2．获得本团体服务的优先权和优惠权；</div>
    <div class="vipBox-text">
      3．持证会员有资格参加本团体组织或推荐的各类奖项，以及先进的评选活动；
    </div>
    <div class="vipBox-text">
      4. 在本团体组织的行业人才举荐活动中，持证会员在同等条件下，将被优先推荐；
    </div>
    <div class="vipBox-text">
      5.
      持证会员可优先参加本团体组织的国内外学术会议、展览展示、技术服务、业务咨询、教育培训、科学普及等活动，并享受会员价格优惠；
    </div>
    <div class="vipBox-text">
      6.
      在同等条件下，持证会员可优先在本团体主办的综合性科技期刊上发表论文或在学术会议上进行交流；
    </div>
    <div class="vipBox-text">
      7. 持证会员在购买本团体编辑出版的工具书、学术论文资料时，可享受价格优惠；
    </div>
    <div class="vipBox-text">
      8. 持证会员可免费查看、下载本团体官网上的会员专属信息；
    </div>
    <div class="vipBox-text">9. 持证会员可定期免费阅读《航海》杂志电子版；</div>
    <div class="vipBox-text">10. 对本团体工作的批评权、建议权和监督权；</div>
    <div class="vipBox-text">11. 入会自愿、退会自由。</div>
    <div class="vipBox-title">三、个人会员义务</div>
    <div class="vipBox-text">
      1. 遵守本团体章程，执行本团体的决议，维护本团体的合法权益；
    </div>
    <div class="vipBox-text">
      2. 积极参加和支持本会开展的各类学术、技术活动；
    </div>
    <div class="vipBox-text">3. 向本团体反映情况，提供有关信息、资料等；</div>
    <div class="vipBox-text">4. 按本团体章程规定缴纳会费。</div>
    <div class="button" @click="closerClick">关闭</div>
  </div>
</template>
<script>
export default {
  methods: {
    closerClick() {
      this.$emit("closer");
    }
  }
};
</script>
<style lang="less">
.vipBox {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  padding: 16px;
  overflow: auto;
  background: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  z-index: 999;
  .vip-h1 {
    text-align: center;
    margin-bottom: 10px;
    font-size: 18px;
    color: #6c2c66;
    font-weight: bold;
  }
  .vipBox-title {
    margin-bottom: 10px;
  }
  .vipBox-title1 {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .vipBox-text {
    font-size: 12px;
    margin-bottom: 4px;
    color: #343434;
    line-height: 20px;
    text-indent: 2em;
  }
  .button {
    margin: 30px auto 0;
    width: 320px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background: #6c2c66;
    border-radius: 4px;
    font-size: 18px;
    color: #ffffff;
  }
}
</style>
